import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceforitcompanyinpune() {



  const cardData =
  {
    keyword: 'Cab Service for IT Company in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Cab Service for IT Company in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited provides specialized Cab Service for IT Companies in Pune, offering reliable, efficient, and comfortable transportation tailored to the fast-paced needs of the tech industry. Our fleet of clean, fully air-conditioned sedans, SUVs, and employee-transport vehicles ensures smooth daily commuting for IT staff, managers, and visiting clients. We offer shift-based cabs, dedicated corporate vehicles, flexible monthly rentals, and on-demand chauffeur-driven cars to support all corporate mobility requirements. With professional chauffeurs, GPS-enabled vehicles, strict safety measures, and punctual operations, Pune Corporate Cars India Private Limited delivers seamless, high-quality transportation solutions for IT parks and tech companies across Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "IT Employee Cab Pune",
    "description": "IT Employee Cab Pune delivers reliable, punctual, and secure transportation for IT professionals across Pune’s major tech hubs. Designed for multi-shift operations, the service includes AC cars, verified chauffeurs, real-time tracking, and optimized routes. With smooth coordination and disciplined drivers, IT Employee Cab Pune ensures comfortable and safe daily commute for tech employees working in fast-paced environments."
  },
  {
    "name": "IT Park Cab Service Pune",
    "description": "IT Park Cab Service Pune provides structured cab services for employees working in Hinjewadi, Kharadi, Magarpatta, Viman Nagar, and other tech parks. Our fleet includes sedans, SUVs, and shuttle vans maintained to corporate standards. With shift-based scheduling, GPS-enabled trips, and professional chauffeurs, IT Park Cab Service Pune ensures seamless and efficient travel for IT teams."
  },
  {
    "name": "Office Staff Transport Pune",
    "description": "Office Staff Transport Pune offers dependable commuting for staff working in IT companies, corporate parks, and tech centers. We support fixed-route and multi-route travel with AC vehicles and experienced drivers. Ideal for companies operating early morning, general, and night shifts, Office Staff Transport Pune guarantees timely, comfortable, and safe staff movement."
  },
  {
    "name": "IT Shuttle Service Pune",
    "description": "IT Shuttle Service Pune provides high-capacity transportation for IT parks and corporate campuses. Our AC tempo travellers, minibuses, and shuttle vans ensure efficient employee movement during peak hours. With fixed schedules, optimized routes, and strict safety protocols, IT Shuttle Service Pune is perfect for large IT teams requiring well-managed group mobility."
  },
  {
    "name": "Corporate IT Fleet Pune",
    "description": "Corporate IT Fleet Pune offers fully managed fleet solutions for IT companies requiring sedans, SUVs, vans, and shuttles for daily operations. We handle driver allocation, maintenance, scheduling, and replacements. Corporate IT Fleet Pune helps companies streamline transportation costs and ensures smooth mobility for staff and executives."
  },
  {
    "name": "Tech Park Cab Hire Pune",
    "description": "Tech Park Cab Hire Pune offers tailored cab hire services for employees and executives working in Pune’s major IT zones. Whether for daily commute, executive travel, or client pickups, our clean, AC-equipped vehicles and trained chauffeurs ensure dependable and professional travel. Tech Park Cab Hire Pune supports seamless mobility for tech businesses."
  },
  {
    "name": "Hinjewadi IT Cab Service",
    "description": "Hinjewadi IT Cab Service provides structured transportation for employees working in Phase 1, Phase 2, and Phase 3 of Hinjewadi IT Park. With multi-route coverage, shift-based cab scheduling, and verified drivers, the service ensures safe and timely office commute. Hinjewadi IT Cab Service is ideal for large IT companies and corporate campuses."
  },
  {
    "name": "Kharadi IT Cab Service",
    "description": "Kharadi IT Cab Service offers professional and punctual cab services for employees working in EON IT Park, World Trade Center, Zensar, and surrounding tech areas. With sanitized vehicles, AC comfort, and skilled chauffeurs, Kharadi IT Cab Service guarantees smooth daily travel for IT teams across all shifts."
  },
  {
    "name": "Magarpatta IT Cab Service",
    "description": "Magarpatta IT Cab Service delivers well-organized cab transportation for employees in the Magarpatta Cybercity region. Our service includes dedicated cabs, scheduled pickups, night-shift safety compliance, and comfortable AC vehicles. Magarpatta IT Cab Service ensures safe and hassle-free commuting for IT professionals."
  },
  {
    "name": "Viman Nagar IT Shuttle",
    "description": "Viman Nagar IT Shuttle offers shared shuttle services connecting IT offices with major residential and commercial areas. AC minibuses, shuttle vans, and tempo travellers ensure group travel convenience. With fixed timings and disciplined drivers, Viman Nagar IT Shuttle supports smooth daily mobility for IT employees."
  },
  {
    "name": "IT Business Travel Cabs Pune",
    "description": "IT Business Travel Cabs Pune provides executive-level cabs for meetings, airport transfers, inter-office visits, and corporate events. Vehicles include premium sedans and SUVs with trained chauffeurs. IT Business Travel Cabs Pune ensures professional, comfortable, and efficient business travel for IT teams and executives."
  },
  {
    "name": "Staff Commute for IT Employees",
    "description": "Staff Commute for IT Employees offers structured commuting solutions for IT companies across Pune. From early-morning to late-night shifts, our AC vehicles, monitored travel, and optimized route planning ensure safe and dependable commuting. The service is ideal for IT firms with continuous staff mobility requirements."
  },
  {
    "name": "Dedicated IT Employee Cab",
    "description": "Dedicated IT Employee Cab provides exclusive vehicles assigned to companies for daily employee movement. Perfect for executives, team leads, and essential staff, these dedicated cabs offer consistent availability, trained chauffeurs, and predictable monthly billing. Dedicated IT Employee Cab ensures premium and uninterrupted mobility."
  },
  {
    "name": "Best IT Company Cab Pune",
    "description": "Best IT Company Cab Pune offers premium, safe, and professionally managed cab services tailored for IT organizations. With punctual pickups, sanitized interiors, and courteous drivers, we deliver a top-quality commute experience. Best IT Company Cab Pune is trusted by leading IT companies for daily travel, meetings, and client movement."
  },
  {
    "name": "IT Office Transport Pune",
    "description": "IT Office Transport Pune provides end-to-end transportation management for IT companies, including route planning, shift operations, fleet allocation, and safety monitoring. With AC-equipped vehicles and experienced drivers, IT Office Transport Pune ensures smooth, reliable, and secure travel for IT employees across all major tech corridors."
  }
],
"tableData": [
  ["IT Employee Cab Pune", "IT Park Cab Service Pune"],
  ["Office Staff Transport Pune", "IT Shuttle Service Pune"],
  ["Corporate IT Fleet Pune", "Tech Park Cab Hire Pune"],
  ["Hinjewadi IT Cab Service", "Kharadi IT Cab Service"],
  ["Magarpatta IT Cab Service", "Viman Nagar IT Shuttle"],
  ["IT Business Travel Cabs Pune", "Staff Commute for IT Employees"],
  ["Dedicated IT Employee Cab", "Best IT Company Cab Pune"],
  ["IT Office Transport Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Cab Service for IT Company in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable and efficient cab services specifically designed for IT companies in Pune, ensuring smooth and punctual employee transportation."
  },
  {
    "WhyChooseheading": "Ideal for Major IT Hubs",
    "WhyChoosedescription": "Our services are tailored for key IT hubs like Hinjewadi, Magarpatta, Kharadi, Viman Nagar, and Talawade, offering seamless commuting solutions for large and small IT teams."
  },
  {
    "WhyChooseheading": "Safe, Clean & Comfortable Vehicles",
    "WhyChoosedescription": "All our cabs are regularly maintained, sanitized, and equipped to ensure safe, hygienic, and comfortable travel for IT employees."
  },
  {
    "WhyChooseheading": "Transparent & Corporate-Friendly Pricing",
    "WhyChoosedescription": "We offer clear and competitive pricing with no hidden charges, perfect for daily, monthly, and long-term transportation contracts."
  },
  {
    "WhyChooseheading": "Flexible Pick-Up & Drop Schedules",
    "WhyChoosedescription": "Choose from customized pickup and drop timings to match multiple employee shifts and office hours common in IT companies."
  },
  {
    "WhyChooseheading": "Trained & Professional Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers ensure punctuality, safe driving, and a smooth travel experience for employees and executives."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, schedule changes, emergencies, and shift-based travel needs."
  },
  {
    "WhyChooseheading": "Easy & Fast Booking",
    "WhyChoosedescription": "Book your IT company cab service through our simple online platform or via phone, with quick confirmations and reliable service."
  }
]






















  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited provide cab services for IT companies in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers specialized and fully managed cab services tailored for IT companies across Pune.',
  },
  {
    question: 'How can an IT company book cab services with Pune Corporate Cars India Private Limited?',
    answer: 'IT companies can book through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'Do you offer employee pick-up and drop services for IT companies?',
    answer: 'Yes, we provide efficient and punctual daily pick-up and drop services designed for IT company employees.',
  },
  {
    question: 'What types of vehicles are available for IT company transportation?',
    answer: 'We provide hatchbacks, sedans, SUVs, tempo travellers, and premium cars for IT staff commute and corporate travel.',
  },
  {
    question: 'Can we get monthly or annual cab contracts for IT companies?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers flexible and cost-effective monthly and annual corporate cab contracts for IT companies.',
  },
  {
    question: 'Are the drivers trained for IT company shift timings?',
    answer: 'Absolutely. Our drivers are trained to handle early morning, late-night, and rotational IT shift schedules.',
  },
  {
    question: 'Do you provide real-time tracking for employee transportation?',
    answer: 'Yes, our cabs come with GPS-based tracking to ensure safety and transparency for IT employee transportation.',
  },
  {
    question: 'What safety measures are followed for IT company cab services?',
    answer: 'All vehicles undergo routine sanitization, and drivers follow strict safety and hygiene protocols.',
  },
  {
    question: 'What payment options are available for IT corporate cab services?',
    answer: 'We support UPI, online transfers, credit/debit cards, digital wallets, and corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Shah',
    feedback: 'Pune Corporate Cars India Private Limited provides excellent cab services for IT companies. Their punctuality and professional drivers are impressive.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Prachi Kulkarni',
    feedback: 'We rely on Pune Corporate Cars India Private Limited for our IT employee transportation. Great service, clean cars, and dependable support.',
    rating: 5,
  },
];













































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service for IT Company in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/it-company-cabs-pune.jpg", // replace with actual image URL
  "description": "Reliable cab services for IT companies in Pune, offering employee transport, office shuttle, IT park commute, and corporate business travel cabs. Pune Corporate Cars India Private Limited provides well-maintained sedans, SUVs, and MUVs with chauffeur-driven services for IT employees across Hinjewadi, Kharadi, Magarpatta, Viman Nagar, and other tech parks.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4700", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/it-company-cab-service-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>Cab Service for IT Company in Pune | Employee & IT Park Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable cab services for IT companies in Pune, offering employee transport, office shuttle, IT park commute, and corporate business travel cabs. Chauffeur-driven sedans, SUVs, and MUVs for IT employees across Pune tech parks."
  />

  <meta
    name="keywords"
    content="IT Employee Cab Pune, IT Park Cab Service Pune, Office Staff Transport Pune, IT Shuttle Service Pune, Corporate IT Fleet Pune, Tech Park Cab Hire Pune, Hinjewadi IT Cab Service, Kharadi IT Cab Service, Magarpatta IT Cab Service, Viman Nagar IT Shuttle, IT Business Travel Cabs Pune, Staff Commute for IT Employees, Dedicated IT Employee Cab, Best IT Company Cab Pune, IT Office Transport Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceforitcompanyinpune;